export { Diamond } from "./Diamond";
